import React from 'react'
import { Modal, Button } from '@wmgtech/legato'

import { IZoneConfirmationModalProps } from './ZoneConfirmationModal.props'

import styles from './ZoneConfirmationModal.module.scss'

export const ZoneConfirmationModal: React.FC<IZoneConfirmationModalProps> = ({
  isOpen,
  title,
  text,
  onClose,
  onContinue
}) => {
  const onHandleContinue = () => {
    onContinue()
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      className={styles.container}
      shouldCloseOnOverlayClick={false}
      title={title}
      footer={
        <>
          <Button containerStyle="outline" colorType="secondary-black" label="Cancel" onClick={onClose} />
          <Button containerStyle="solid" colorType="secondary-black" label="Continue" onClick={onHandleContinue} />
        </>
      }
      size="sm"
      onClose={onClose}
    >
      {text}
    </Modal>
  )
}
